import React, { useState } from 'react';
import GridPicker from './GridPicker';

// Uniform multi-pick: chosen items show as chips (x to remove); click opens a grid where each click adds/removes.
// options: [{ value, label, ...columns }]   values: [value]   onChange(newValues)
const chip = { display: 'inline-flex', alignItems: 'center', padding: '2px 10px', margin: '2px 6px 2px 0', borderRadius: 12, background: '#eef2f7', color: '#334155', fontSize: 13 };

export default function GridMultiSelect({ label, values, options, columns, onChange, error, placeholder, disabled, compact, summary }) {
    const [open, setOpen] = useState(false);
    const sel = values || [];
    const byVal = {};
    (options || []).forEach((o) => { byVal[o.value] = o; });
    const toggle = (v) => onChange(sel.includes(v) ? sel.filter((x) => x !== v) : [...sel, v]);
    const rows = (options || []).map((o) => ({ ...o, _sel: sel.includes(o.value) ? '✓' : '\u00A0' }));
    if (compact) {
        const labels = sel.map((v) => (byVal[v] && byVal[v].label) || v);
        const text = summary || (!sel.length ? 'None' : options && sel.length === options.length ? 'All' : labels.join(', '));
        return (
            <div className="bl-compact-ms" style={{ position: 'relative', width: '100%' }}>
                <div onClick={() => { if (!disabled) setOpen(!open); }} title={labels.join(', ')}
                    style={{ border: `1px solid ${error ? '#dc3545' : '#c4c4c4'}`, borderRadius: 4, height: 56, padding: '0 40px 0 14px', display: 'flex', alignItems: 'center', cursor: disabled ? 'default' : 'pointer', background: '#fff', position: 'relative' }}>
                    {label && <span style={{ position: 'absolute', top: -9, left: 10, background: '#fff', padding: '0 4px', fontSize: 12, color: 'rgba(0,0,0,0.6)' }}>{label}</span>}
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 16 }}>{text}</span>
                    <i className="fas fa-th-list" style={{ position: 'absolute', right: 14, top: 20, color: '#6c757d' }}></i>
                </div>
                {open && (
                    <div style={{ position: 'absolute', top: 60, left: 0, zIndex: 1400, width: 'max(100%, 440px)', background: '#fff', border: '1px solid #dee2e6', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,.15)', padding: 8 }}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                            <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => onChange((options || []).map((o) => o.value))}>Select all</button>
                            <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => onChange([])}>Clear</button>
                            <span style={{ fontSize: 12, color: '#6c757d', marginLeft: 'auto' }}>{sel.length} of {(options || []).length} selected</span>
                            <button type="button" className="btn btn-sm btn-success" onClick={() => setOpen(false)}>Done</button>
                        </div>
                        <GridPicker rows={rows}
                            columns={[{ key: '_sel', label: '✓', width: '8%' }, ...(columns || [{ key: 'label', label: 'Name', bold: true }])]}
                            placeholder={placeholder || 'Search…'} onClose={() => setOpen(false)} onSelect={(r) => toggle(r.value)} />
                    </div>
                )}
            </div>
        );
    }
    return (
        <div>
            <div
                onClick={() => { if (!disabled) setOpen(!open); }}
                style={{ border: `1px solid ${error ? '#dc3545' : '#c4c4c4'}`, borderRadius: 4, minHeight: 56, padding: '10px 40px 6px 12px', position: 'relative', cursor: disabled ? 'default' : 'pointer', background: '#fff' }}
            >
                <span style={{ position: 'absolute', top: -9, left: 10, background: '#fff', padding: '0 4px', fontSize: 12, color: error ? '#dc3545' : 'rgba(0,0,0,0.6)' }}>{label}</span>
                {sel.length ? (
                    sel.map((v) => (
                        <span key={v} style={chip}>
                            {(byVal[v] && byVal[v].label) || v}
                            {!disabled && <i className="fas fa-times ml-2" style={{ cursor: 'pointer', fontSize: 11, color: '#64748b' }} onClick={(e) => { e.stopPropagation(); toggle(v); }}></i>}
                        </span>
                    ))
                ) : (
                    <span style={{ color: '#9aa0a6', lineHeight: '34px' }}>Click to choose…</span>
                )}
                <i className="fas fa-th-list" style={{ position: 'absolute', right: 14, top: 20, color: '#6c757d' }}></i>
            </div>
            {open && (
                <GridPicker
                    rows={rows}
                    columns={[{ key: '_sel', label: '✓', width: '7%' }, ...(columns || [{ key: 'label', label: 'Name', bold: true }])]}
                    placeholder={placeholder || 'Search…'}
                    onClose={() => setOpen(false)}
                    onSelect={(r) => toggle(r.value)}
                />
            )}
            {open && <div style={{ fontSize: 12, color: '#6c757d', marginTop: 4 }}>{sel.length} selected · click rows to add or remove · Close when done</div>}
        </div>
    );
}
